import { Fragment } from 'react';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'next-i18next';
import Link from '@/components/Link';
import { Button } from '@forma/forma-ui-kit';

import styles from './page-title.module.css';

const PageTitle = ({ breadcrumbs, title }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <ul className={styles.breadcrumbs}>
        <li className={styles.item}>
          <Link className={styles.link} href="/">{t('homepage')}</Link>
        </li>
        <li className={styles.item}>
          <ReactSVG className={styles.icon} src="/icons/arrow-right.svg" />
        </li>
        {breadcrumbs.map(({ name, href }, index) => (
          <Fragment key={index}>
            <li className={styles.item}>
              {href ? (
                <Link className={styles.link} href={href}>{name}</Link>
              ) : (
                <span className={styles.text}>{name}</span>
              )}
            </li>
            {index < breadcrumbs.length - 1 &&
              <li className={styles.item}>
                <ReactSVG className={styles.icon} src="/icons/arrow-right.svg" />
              </li>
            }
          </Fragment>
        ))}
      </ul>
      <div className={styles.header}>
        <Button
          as={Link}
          className={styles.back}
          viewStyle="secondary"
          iconClassName={styles.backIcon}
          icon={<ReactSVG src="/icons/arrow-left-2.svg" wrapper="span" />}
          href="/"
        />
        <h1 className={styles.title}>
          {title}
        </h1>
      </div>
    </div>
  );
};

export default PageTitle;
